import styled from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'

export const CentredRow = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: tokens.spacing[5]
})
